const SUBSCRIPTION = 'SUBSCRIPTION';

export const getSubscription = (store) => store[SUBSCRIPTION].fetch;
